// src/components/WidgetContainer.tsx

import React from 'react';
import { AvailableWidgets } from '../types/AvailableWidgets';

interface WidgetContainerProps {
  widgetName: string;
}

export const WidgetContainer: React.FC<WidgetContainerProps> = ({ widgetName }) => {
  const widgetInfo = AvailableWidgets.find((widget) => widget.key === widgetName);
  if (!widgetInfo) {
    return <div>Widget not found</div>;
  }
  const WidgetComponent = widgetInfo.component;
  return <WidgetComponent />;
};